export class Pais {
    public static CODIGO_COLOMBIA: Number = 57;
    public static CODIGO_PANAMA: Number = 207;
    public static CIA_MATRIZ_COLOMBIA: String = '00';
    public static CIA_MATRIZ_PANAMA: String = '30';
    public static CODIGO_DELEGACION_COLOMBIA: String = 'Suracom';
    public static CODIGO_DELEGACION_PANAMA: String = 'SuracomPanama';
}



// WEBPACK FOOTER //
// ./src/app/contants/pais.constant.ts